<div class="w-[850px] max-w-[100%] mx-auto mt-4 mb-4" style="box-shadow: 0 0 25px #ccc;">
  <!-- Header Section -->
  <div class="bg-marty-slateblue text-white text-center py-4 px-6">
    <h2 class="text-xl sm:text-2xl font-light oswald uppercase" [innerHTML]="title">
    </h2>
  </div>
  
  <!-- Content Section with Padding -->
  <div class="p-6">

  <!-- Main Content Section -->
  <div class="flex flex-col sm:flex-row gap-6 items-center">
    <!-- Left Column - Product Image -->
    <div class="flex-shrink-0 w-full sm:w-1/2 flex justify-center">
      <div class="relative max-w-sm">
        <img 
          src="{{image}}" 
          alt="{{imageAlt}}" 
          class="w-auto h-auto max-h-96 object-contain"
        >
      </div>
    </div>

    <!-- Right Column - Offer Details -->
    <div class="flex-1 w-full sm:w-1/2 space-y-4">
      <div class="text-center" [ngClass]="{'hasTitle': showTitle}">
        <p class="font-bold text-marty-darkFont mb-4 uppercase" [innerHTML]="subTitle">
        </p>
        
        <div class="space-y-3">
          <div class="border-t border-marty-darkFont pt-3">
            <p class="text-marty-darkFont mb-0">
              <span class="font-medium text-[24px]">{{regularText}} </span> 
              <span class="text-[24px]">{{ regularPrice | dynamicCurrency:currency }}</span>
            </p>
            <p class="text-marty-gold font-semibold">
              <span class="text-[24px]">{{instantSavingsText}} </span> 
              <span class="text-[24px]">{{ instantSavings | dynamicCurrency:currency }}</span>
            </p>
          </div>
          
          <div class="border-t border-marty-darkFont pt-3">
            <p class="text-marty-darkFont font-bold text-xl">
              <span class="font-bold text-[28px]">{{yourPriceText}} </span> 
              <span class="font-bold text-[28px]">{{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
